import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { Theme, ThemeDetails } from '@yandex-int/k-common/typings';
import isNil from 'lodash/isNil';
import { LessonInfo, Text } from 'platform-components';
import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import ym from 'react-yandex-metrika';

import { MetrikaParams } from 'common.components/hooks/use-prep-lesson-click';
import hasScrolledToElement from 'utils/has-scrolled-to-element';

import PromoPrepLessons from '../__prep-lessons/promo__prep-lessons';
// @ts-ignore
import COLORS from '../../../../../design/colors';

import './promo__theme.view.scss';

interface Props {
    shouldShowId: boolean;
    theme: Theme;
    promoThemeId?: number;
    scrollToTheme?: (themeRef: React.RefObject<HTMLDivElement>) => void;
    prepLessons: Array<LessonInfo>;
    now: Date | null;
    loadingStatus: LOADING_STATUSES;
    prepLessonsDetailsLoadingStatus: LOADING_STATUSES;
    themeDetailsLoadingStatus: LOADING_STATUSES;
    themeDetails: ThemeDetails | null;
    metrikaParams: MetrikaParams;
}

const PromoThemeView = (props: Props) => {
    const {
        shouldShowId,
        theme,
        themeDetails,
        promoThemeId,
        scrollToTheme,
        prepLessons,
        now,
        loadingStatus,
        prepLessonsDetailsLoadingStatus,
        themeDetailsLoadingStatus,
        metrikaParams,
    } = props;
    const { name } = theme;
    const { lessons_count: prepLessonsCount } = themeDetails || {};
    const themeRef = useRef<HTMLDivElement | null>(null);
    const [isMetrikaSent, setIsMetrikaSent] = useState(false);

    useEffect(() => {
        if (!isSSR) {
            window.addEventListener('scroll', scrollHandler);

            return () => window.removeEventListener('scroll', scrollHandler);
        }

        return () => {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // eslint-disable-next-line complexity
    useEffect(() => {
        const scrollIsSafe = themeRef && themeRef.current;
        const isLoaded =
            loadingStatus === LOADING_STATUSES.SUCCESS &&
            themeDetailsLoadingStatus === LOADING_STATUSES.SUCCESS &&
            prepLessonsDetailsLoadingStatus === LOADING_STATUSES.SUCCESS;

        if (scrollIsSafe && isLoaded && promoThemeId && promoThemeId === theme.id && scrollToTheme) {
            scrollToTheme(themeRef);
        }
    }, [
        loadingStatus,
        themeDetailsLoadingStatus,
        prepLessonsDetailsLoadingStatus,
        scrollToTheme,
        promoThemeId,
        theme.id,
        themeRef,
    ]);

    const scrollHandler = () => {
        if (themeRef && themeRef.current) {
            const isScrolledIntoView = hasScrolledToElement(ReactDOM.findDOMNode(themeRef.current));

            if (isScrolledIntoView && !isMetrikaSent) {
                ym('reachGoal', 'teacher_vitrina_block_shown', metrikaParams);
                setIsMetrikaSent(true);

                if (!isSSR) {
                    window.removeEventListener('scroll', scrollHandler);
                }
            }
        }
    };

    return (
        <div className="promo__theme" ref={themeRef}>
            <div className="promo__theme-header">
                {/* порядок инвертирован, чтобы красиво wrap на css работал */}
                {shouldShowId && (
                    <Text color={COLORS.blackCommInit} size={Text.SIZE.XL}>
                        ID: {theme.id}
                    </Text>
                )}
                {!isNil(prepLessonsCount) && (
                    <Text
                        color={COLORS.blackCommInit}
                        id="promoThemes.theme.lessonsCount"
                        size={Text.SIZE.XL}
                        values={{ count: prepLessonsCount }}
                    />
                )}
                <div className="promo__theme-name">
                    <Text size={Text.SIZE.XXL} weight={Text.WEIGHT.M}>
                        {name}
                    </Text>
                </div>
            </div>
            <div className="promo__prep-lessons">
                <PromoPrepLessons
                    isLoading={loadingStatus === LOADING_STATUSES.LOADING || loadingStatus === LOADING_STATUSES.UNSENT}
                    metrikaParams={metrikaParams}
                    now={now}
                    prepLessons={prepLessons}
                />
            </div>
        </div>
    );
};

export default PromoThemeView;
